import { useEffect, useRef } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedCategories from './components/FeaturedCategories';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { applySeo, getHomePageSeo, getOrganizationSchema, getFaqSchema, getBreadcrumbSchema } from '@/utils/seo';
import { faqItems } from '@/mocks/faq';

export default function HomePage() {
  const schemaInjected = useRef(false);

  useEffect(() => {
    applySeo(getHomePageSeo());

    if (!schemaInjected.current) {
      schemaInjected.current = true;
      const schemas = [
        getOrganizationSchema(),
        getFaqSchema(faqItems),
        getBreadcrumbSchema([{ name: '首页', url: 'https://trainology.github.io' }]),
      ];
      schemas.forEach((schema) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
      });
    }
  }, []);

  return (
    <main>
      <Navbar />
      <HeroSection />
      <FeaturedCategories />
      <LatestArticles />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}